// extracted by mini-css-extract-plugin
export default {"errorContainer":"Dashboard_errorContainer__Or3vo"};